import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

const AnalyticsCard = ({ icon, title, value, loading }) => {
  return (
    <Box className="profile-analytics-card">
      {loading ? (
        <>
          <Box className="profile-analytics-card-text">
            <Skeleton width={92} />
            <Skeleton width={72} height={34} />
          </Box>
          <Skeleton variant="circular" width={44} height={44} />
        </>
      ) : (
        <>
          <Box className="profile-analytics-card-text">
            <Typography variant="body2" className="profile-analytics-card-title">
              {title}
            </Typography>
            <Typography className="profile-analytics-card-value">{value}</Typography>
          </Box>
          <Box className="profile-analytics-card-icon">{icon}</Box>
        </>
      )}
    </Box>
  );
};

export default AnalyticsCard;
